
var dzsHelpers = require('../js_common/_dzs_helpers');
exports.generateThumbnailForVideo = function(videoSource, videoType, _con){

  console.log('videoSource - ', videoSource, videoType);


  var $ = jQuery;





  return new Promise((resolve,reject)=>{


    if (videoType == 'video') {


      // -- try to generate image
      if (window.dzsvg_settings && dzsvg_settings.admin_try_to_generate_thumb_for_self_hosted_videos == 'on') {


        $('.dzs-single-upload-preview-img').addClass('generating-thumb');


        var source = _con.find('*[name=dzsvg_meta_featured_media]').eq(0).val();


        var aux43 = '<div class="screenshot-canvas-con';


        if (window.dzsvg_settings && window.dzsvg_settings.debug_mode == 'on') {
          aux43 += ' debug-mode';
        }


        aux43 += '"><video crossOrigin="Anonymous" class="temp-screenshot-video" width="600" height="400" src="' + source + '" style="opacity: 0;"></video><canvas crossOrigin="Anonymous" width="600" height="400" class="temp-screenshot-canvas" style="opacity: 0;"></canvas></div>';


        _con.after(aux43);

        // console.warn('_con - ', videoType);
        // console.warn('aux43 - ', aux43);


        var _c = _con.next();
        var $canvas_ = _c.find('canvas').get(0);
        var $canvasContext_ = $canvas_.getContext('2d');
        var $videoElement_ = _c.find('video').get(0);

        _c.find('video').get(0).currentTime = 5;

        console.log('$videoElement_ - ', $videoElement_);

        $videoElement_.addEventListener('error', (err)=>{
          console.log("VIDEO ERROR ", err);

          reject('');
        })

        setTimeout(function () {

          $canvasContext_.drawImage($videoElement_, 0, 0);


          var xhr = null;

          var canvasData = $canvas_.toDataURL("image/png");
          var xmlHttpReq = false;
          if (window.XMLHttpRequest) {
            xhr = new XMLHttpRequest();
          }

          xhr.open('POST', dzsvg_settings.dzsvg_site_url + '/?dzsvg_action=savescreenshot&name=' + encodeURIComponent(source), true);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.onreadystatechange = function () {
            // console.log(ajax.responseText);
            var response = xhr.responseText;

            if (xhr.readyState == 4 && xhr.status == 200) {

              // _con.find('*[name=dzsvg_meta_thumb]').val(response);
              _con.find('*[name=dzsvg_meta_thumb]').trigger('change');
              // _auxcon.find('.dzs-single-upload-preview-img').css('background-image', 'url('+response+')');
              $('.dzs-single-upload-preview-img').removeClass('generating-thumb');

              $('.screenshot-canvas-con:not(.debug-mode)').remove();

              resolve(response);

            }
          }
          console.log('canvasData - ', canvasData);
          xhr.send("imgData=" + canvasData);

        }, 4500);


      }

    }
    if (videoType == 'vimeo') {

      var _thumbfield = _con.find('*[name=dzsvg_meta_thumb]').eq(0);

      if (_thumbfield.val() == '') {
        //_con.find('.main-thumb').eq(0).val('http://img.youtube.com/vi/'+_t.val()+'/0.jpg');


        var data = {
          action: 'dzsvg_vimeo_get_vimeothumb',
          postdata: _con.find('*[name=dzsvg_meta_featured_media]').eq(0).val()
        };

        jQuery.post(ajaxurl, data, function (response) {
          //console.log(response);
          if (window.console != undefined) {
            //console.log(response);
          }
          if (response.substr(0, 6) == 'error:') {
            //console.log('ceva');

            alert(response.substr(7));
            jQuery('.import-error').fadeIn('fast').delay(5000).fadeOut('slow');
            return false;
          }
          resolve(response);

        });
      }
    }

    if (videoType == 'youtube') {


      resolve('https://img.youtube.com/vi/' + dzsHelpers.sanitize_to_youtube_id(videoSource) + '/0.jpg');
    }
  })


}


exports.generateThumbnailForField = function($autoGenerateButton_){

  // -- refresh main thumbnail

  var $ = jQuery;
  var _t = $($autoGenerateButton_);
  var $item_tabContent = null;
  var adminHelpers = this;


  console.info('_t - ', _t);
  console.info('_t.parent().parent() - ', _t.parent().parent());
  console.warn('refresh main-thumb _con - ', $item_tabContent);


  if (_t.parent().parent().hasClass('select-hidden-con')) {
    $item_tabContent = _t.parent().parent();
  }
  if (_t.parent().parent().parent().hasClass('select-hidden-con')) {
    $item_tabContent = _t.parent().parent().parent();
  }
  if (_t.parent().parent().parent().hasClass('tab-content')) {
    $item_tabContent = _t.parent().parent().parent();
  }

  console.info('_con - ', $item_tabContent);

  if ($item_tabContent) {

    const videoSource = $item_tabContent.find('*[name="dzsvg_meta_featured_media"]').eq(0).val();
    let videoType = $item_tabContent.find('select[name="dzsvg_meta_item_type"]').eq(0).val();
    var $itemThumbnailField = $item_tabContent.find('*[name=dzsvg_meta_thumb]').eq(0);


    if (videoType == 'detect' || videoType == '') {
      videoType = dzsHelpers.detect_video_type_and_source(videoSource).type;
      console.log('detected video type - ', videoType);
    }

    if (videoType == 'detect' || videoType == '') {
      videoType = 'video';
    }
    console.info('videoSource - ', videoSource, 'videoType - ', videoType);
    const videoThumbComputed = adminHelpers.generateThumbnailForVideo(videoSource, videoType, $item_tabContent).then(result => {


      console.log('result -  ', result, '... $item_tabContent - ', $item_tabContent);


      // console.log('_thumbfield- ', _thumbfield);
      $itemThumbnailField.val(result).trigger('change');


      // console.warn('type - ', videoType, videoType == 'video', ' window.dzsvg_settings - ', window.dzsvg_settings);
      // console.warn('_con - ', $item_tabContent);


    }).catch(err => {
      console.log(err);

    });


    console.log('videoThumbComputed - ', videoThumbComputed)


  } else {
    console.log('[dzsvg][admin][warning] _con is null - ', $item_tabContent, _t);
  }
}